/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SocialIconOverlay_photo = {
    readonly path: string | null;
    readonly " $refType": "SocialIconOverlay_photo";
};
export type SocialIconOverlay_photo$data = SocialIconOverlay_photo;
export type SocialIconOverlay_photo$key = {
    readonly " $data"?: SocialIconOverlay_photo$data;
    readonly " $fragmentRefs": FragmentRefs<"SocialIconOverlay_photo">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SocialIconOverlay_photo",
  "type": "TradePhoto",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'a49ee47888ae67496cc7b981a95fac61';
export default node;
